var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAvailableProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#D7F3E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66663V9.99996M4 6.66663C4 8.70964 4 13.1828 4 13.4408C4 14.3625 5.2971 14.9104 7.89129 16.0063C8.93346 16.4465 9.45455 16.6666 10 16.6666L10 9.56985",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6667C12 14.6667 12.5833 14.6667 13.1667 16C13.1667 16 15.0196 12.6667 16.6667 12",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55061 8.46096L5.60314 7.5186C4.53438 7.00144 4 6.74286 4 6.33337C4 5.92389 4.53438 5.66531 5.60314 5.14814L7.55061 4.20579C8.75256 3.62418 9.35353 3.33337 10 3.33337C10.6465 3.33337 11.2474 3.62418 12.4494 4.20578L14.3969 5.14814C15.4656 5.66531 16 5.92389 16 6.33337C16 6.74286 15.4656 7.00144 14.3969 7.5186L12.4494 8.46096C11.2474 9.04257 10.6465 9.33337 10 9.33337C9.35353 9.33337 8.75256 9.04257 7.55061 8.46096Z",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10L7.33333 10.6667",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 4.66663L6.66602 7.99996",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvailableProduct);
export default __webpack_public_path__ + "static/media/icon-available-product.a975afecd14870cacc6c3b773890ce0d.svg";
export { ForwardRef as ReactComponent };